// Shared labels and formatting for the super admin App Installs pages.

export const STATUS = {
    active: {label: 'Active', color: 'success', hint: 'Used on at least 2 of the last 7 days'},
    new: {label: 'New', color: 'info', hint: 'Installed in the last 3 days'},
    idle: {label: 'Idle', color: 'warning', hint: 'Seen in the last 7 days but hardly used'},
    inactive: {label: 'Inactive', color: 'grey', hint: 'Not seen for 8 to 30 days'},
    stale: {label: 'Stale', color: 'error', hint: 'Not seen for over 30 days, probably uninstalled'},
}

export const APPS = {
    fleet: {label: 'Fleet', color: 'primary'},
    go: {label: 'Go', color: 'teal'},
    driver: {label: 'Driver', color: 'deep-purple'},
}

// Daily bar colours. A day is green at 10+ minutes, amber at 2-10, red when the
// app was opened for under 2 minutes, grey when it was not opened.
export const USAGE_LEVELS = [
    {key: 'good', label: '10+ min', color: '#2E7D32'},
    {key: 'some', label: '2-10 min', color: '#F9A825'},
    {key: 'brief', label: 'Opened, under 2 min', color: '#C62828'},
    {key: 'none', label: 'Not opened', color: '#BDBDBD'},
]

export const usageLevel = (day) => {
    const minutes = day.foreground_seconds / 60
    if (minutes >= 10) return USAGE_LEVELS[0]
    if (minutes >= 2) return USAGE_LEVELS[1]
    if (day.opens > 0 || day.foreground_seconds > 0) return USAGE_LEVELS[2]
    return USAGE_LEVELS[3]
}

export const platformIcon = (platform) => (platform === 'ios' ? 'mdi-apple' : 'mdi-android')

export const phoneType = (item) => {
    const os = item.platform === 'ios' ? 'iOS' : 'Android'
    return [item.device_model, item.os_version ? `${os} ${item.os_version}` : os].filter(Boolean).join(' · ')
}

export const versionLabel = (item) => {
    if (!item.app_version) return '-'
    return item.app_build ? `${item.app_version} (${item.app_build})` : item.app_version
}

export const shortId = (id) => (id ? id.slice(0, 8) : '-')

export const formatDate = (iso) => {
    if (!iso) return '-'
    return new Date(iso).toLocaleDateString('en-US', {year: 'numeric', month: 'short', day: 'numeric'})
}

export const formatDateTime = (iso) => {
    if (!iso) return '-'
    return new Date(iso).toLocaleString('en-US', {
        year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit',
    })
}

export const relativeTime = (iso) => {
    if (!iso) return '-'
    const minutes = Math.round((Date.now() - new Date(iso).getTime()) / 60000)
    if (minutes < 1) return 'just now'
    if (minutes < 60) return `${minutes} min ago`
    const hours = Math.round(minutes / 60)
    if (hours < 24) return `${hours}h ago`
    const days = Math.round(hours / 24)
    if (days < 60) return `${days}d ago`
    return formatDate(iso)
}

export const formatMinutes = (seconds) => {
    const minutes = Math.round(seconds / 60)
    if (minutes < 60) return `${minutes} min`
    return `${Math.floor(minutes / 60)}h ${minutes % 60}m`
}
